import React, { useCallback, useContext, useEffect, useState } from "react";
import { FireBaseContext } from "../../Context/FireBase";
import { where, query, onSnapshot, getDocs } from "firebase/firestore";
import { TablePagination, TextField } from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as XLSX from "xlsx";

function FranchiseReport() {
  const { TeamsRefrence, EventRefrence, UserRef, getData } =
    useContext(FireBaseContext);
  const [informations, setInformations] = useState([]);
  const [informationUsers, setInformationUsers] = useState([]);
  const [selectedFranchise, setSelectedFranchise] = useState("");

  const [loading, setLoading] = useState(true);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [page, setPage] = useState(0);

  // useEffect(() => {
  //   getData(UserRef, setInformationUsers);
  //     setLoading(false);
  // }, [UserRef, getData]);

  const fetchData = useCallback(() => {
    getData(UserRef, setInformationUsers);
    setLoading(false);
  }, [UserRef, getData]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const getUsersData = () => {
    onSnapshot(TeamsRefrence, async (snapshot) => {
      const franchises = await Promise.all(
        snapshot.docs.map(async (item) => {
          const ref = await getDocs(
            query(EventRefrence, where("Franchise", "==", item.id))
          );
          const franchiseData = ref.docs.map((info) => ({
            ...info.data(),
            ID: info.id,
          }));

          const transformedName = item.id.replace("Franchise", " Franchise");

          // Get the count of users in this franchise
          const franchiseUsers = informationUsers.filter(
            (user) => user.Role.franchiseType === transformedName
          );

          return {
            name: transformedName,
            totalEvents: franchiseData.length,
            totalUsers: franchiseUsers.length,
          };
        })
      );

      setInformations(franchises);
    });
  };

  useEffect(() => {
    if (informationUsers.length > 0) {
      getUsersData();
    }
  }, [informationUsers]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFranchiseChange = (event) => {
    setSelectedFranchise(event.target.value);
  };

  const filteredRows = informations.filter((info) => {
    return selectedFranchise ? info.name === selectedFranchise : true;
  });

  const exportToExcel = (data) => {
    // Create a new workbook and a new worksheet
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(data);

    // Append the worksheet to the workbook
    XLSX.utils.book_append_sheet(wb, ws, "All Users");

    let filename = "franchise_data.xlsx";

    if (selectedFranchise) {
      filename = `${selectedFranchise}.xlsx`;
    }
    XLSX.writeFile(wb, filename);
  };

  const handleExport = () => {
    // Call the export function with the filtered rows
    const excelFilter = filteredRows.map((row) => {
      return {
        "Franchise Type": row.name,
        "Total Events": row.totalEvents,
        "Total Users": row.totalUsers,
      };
    });
    if (excelFilter.length) {
      exportToExcel(excelFilter);
    } else {
      toast.error("There is No data to Export", { autoClose: 4000 });
    }
  };

  return (
    <div className="d-flex flex-column container-fluid container-md gap-3">
      <ToastContainer />
      <h2 className="mb-4">Franchises Report</h2>
      {loading ? (
        <div
          className="w-100 flex justify-center items-center"
          style={{ height: "calc(100vh - 250px) " }}
        >
          <div className="dot-spinner">
            <div className="dot-spinner__dot"></div>
            <div className="dot-spinner__dot"></div>
            <div className="dot-spinner__dot"></div>
            <div className="dot-spinner__dot"></div>
            <div className="dot-spinner__dot"></div>
            <div className="dot-spinner__dot"></div>
            <div className="dot-spinner__dot"></div>
            <div className="dot-spinner__dot"></div>
          </div>
        </div>
      ) : (
        <div className="bg-white p-3 rounded-md ">
          <div className="flex justify-between items-center">
            <div className="flex justify-start items-center gap-4">
              <div className="w-80">
                <label
                  className="block text-black text-sm font-bold mb-2 w-fit"
                  htmlFor="select2"
                >
                  Filter Franchise
                </label>
                <TextField
                  select
                  value={selectedFranchise}
                  onChange={handleFranchiseChange}
                  SelectProps={{
                    native: true,
                  }}
                  variant="outlined"
                  className="border-bottom w-100"
                >
                  <option value="">All</option>
                  <option value="Immunology & Neuroscience">
                    Immunology & Neuroscience
                  </option>
                  <option value="gtx">Gtx</option>
                  <option value="oncology">Oncology</option>
                  <option value="cardiovascular">Cardiovascular</option>
                  <option value="medical">Medical</option>
                  <option value="Value, Access & KAM">
                    Value, Access & KAM
                  </option>
                  <option value="BE&E">BE&E</option>
                </TextField>
              </div>
            </div>

            <div className="px-3">
              <button
                onClick={handleExport}
                className="btn btn-success text-white"
              >
                <i className="fa-solid fa-file-arrow-down fs-5 text-white mr-2"></i>
                <span>EXPORT</span>
              </button>
            </div>
          </div>

          <div className="overflow-x-auto mt-4 mb-6 ">
            <table className="min-w-full bg-white  rounded-lg  text-center ">
              <thead className=" text-black  text-lg border-b border-gray-200">
                <tr>
                  <th className="w-1/6 py-3 px-4">Franchise</th>
                  <th className="w-1/6 py-3 px-4">Total Events</th>
                  {/* <th className="w-1/6 py-3 px-4">Events Cost</th> */}
                  <th className="w-1/6 py-3 px-4">Total Users</th>
                </tr>
              </thead>
              <tbody className="">
                {filteredRows
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((item, index) => (
                    <tr
                      key={index}
                      className="text-blueColor font-normal border-b  odd:bg-white  even:bg-gray-100 "
                    >
                      <td className="py-3 px-4">{item.name}</td>
                      <td className="py-3 px-4">{item.totalEvents}</td>
                      <td className="py-3 px-4">{item.totalUsers}</td>
                      {/* <td className="py-3 px-4">
                    {FormateCost(
                      item.eventCost,
                      item.EventCurrency || "Saudi Riyal"
                    )}
                  </td> */}
                    </tr>
                  ))}
              </tbody>
            </table>

            <div className="my-3">
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={filteredRows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default FranchiseReport;

// const getFranchiseData = async () => {
//   onSnapshot(TeamsRefrence, async (snapshot) => {
//     const franchises = await Promise.all(
//       snapshot.docs.map(async (item) => {
//         const ref = await getDocs(
//           query(EventRefrence, where("Franchise", "==", item.id))
//         );
//         const franchiseData = ref.docs.map((info) => ({
//           ...info.data(),
//           ID: info.id,
//         }));

//         const data = {
//           name: item.id.replace("Franchise", " Franchise"),
//           totalEvents: franchiseData.length,
//           eventCost: franchiseData.reduce(
//             (acc, event) => acc + (event.eventCost || 0),
//             0
//           ),
//           data: franchiseData,
//         };

//         return data;
//       })
//     );
//     setInformations(franchises);
//   });
// };

// useEffect(() => {
//   getFranchiseData();
// }, []);
